import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appWhiteButton]'
})
export class WhiteButtonDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {
    const classes = ['btn', 'btn-light', 'text-uppercase', 'text-dark', 'fw-bold', 'fw-bold', "fs-button-small"];

    classes.forEach((className) => {
      this.renderer.addClass(this.el.nativeElement, className);
    });
  }
}
